<div class="container p-5 text-center">

    <div class="card bg-dark rounded shadow border-primary">
        <div class="card-body text-white">
          <i class="bi bi-cart-plus fs-1 mb-5"></i>
          <h3>{{ 'menu.sell' | translate }}</h3>
        </div>
      </div>

    <div *ngIf="ticketTypes" class="justify-content-center mt-5">
        @for(ticketType of ticketTypes; track ticketType) {
        <a href="#" [routerLink]="'/sale-form/'+ticketType.id" class="card bg-info text-decoration-none rounded shadow border-primary text-white mb-3">
            <div class="card-body">
                <h6 class="p-3 m-0">#{{ ticketType.id }} - {{ ticketType.name }}</h6>
                <small class="badge bg-dark me-3">{{ticketType.price | currency:'HUF':'Ft ':'1.0-0' }}</small>
                <small class="badge bg-dark">{{ ticketType.valid_from | date }} </small>
            </div>
        </a>
        }
    </div>
</div>